import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

export class ConstantService {
    static async getConstantList(_code: string, _parentConstantId: string | undefined = undefined, _additionalValue1: string | undefined = undefined, _isGetNotActives: boolean = false, _additionalValue2: string | undefined = undefined, _additionalValue3: string | undefined = undefined) {
        try {
            var inputObj = {
                code: _code,
                parentConstantId: _parentConstantId,
                additionalValue1: _additionalValue1,
                isGetNotActives: _isGetNotActives,
                additionalValue2: _additionalValue2,
                additionalValue3: _additionalValue3
            };

            console.log('SERVICE CALL - getConstantList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Constant/getConstantList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addConstant(_constantId: string | undefined, _code: string, _value: string, _parentConstantId: string | undefined, _additionalValue1: string | undefined = undefined, _additionalValue2: string | undefined = undefined, _additionalValue3: string | undefined = undefined, _isCustomActive: boolean | undefined = undefined) {
        try {
            var inputObj = {
                constantId: _constantId,
                code: _code,
                value: _value,
                parentConstantId: _parentConstantId,
                additionalValue1: _additionalValue1,
                additionalValue2: _additionalValue2,
                additionalValue3: _additionalValue3,
                isCustomActive: _isCustomActive
            }

            console.log('SERVICE CALL - AddConstant', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Constant/AddConstant', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteConstant(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteConstant', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Constant/deleteConstant', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getConstantById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getConstantById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Constant/getConstantById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}